import { SVGProps } from 'react';

export const ExclamationIcon: React.FunctionComponent<{
  readonly fillBackground?: SVGProps<SVGPolygonElement>['fill'];
  readonly fillExclamationMark?: SVGProps<SVGPolygonElement>['fill'];
  readonly height?: SVGProps<SVGElement>['height'];
  readonly className?: SVGProps<SVGElement>['className'];
  readonly width?: SVGProps<SVGElement>['width'];
}> = ({
  className,
  fillBackground = 'var(--color-red-error-light-mode)',
  fillExclamationMark = 'var(--color-white)',
}) => (
  <svg
    className={className}
    fill="none"
    version="1.1"
    viewBox="0 0 24 28"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      clipRule="evenodd"
      d="M0.158771 23.0374C-0.315229 23.9264 0.329104 25.0001 1.33644 25.0001H22.6634C23.6711 25.0001 24.3154 23.9264 23.8411 23.0374L13.1774 3.70675C12.6754 2.76442 11.3248 2.76442 10.8224 3.70675L0.158771 23.0374Z"
      fill={fillBackground}
      fillRule="evenodd"
    />

    <path
      clipRule="evenodd"
      d="M12 22C11.4478 22 11 21.5522 11 21C11 20.4477 11.4478 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5522 12.5523 22 12 22ZM13 11H11V18H13V11Z"
      fill={fillExclamationMark}
      fillRule="evenodd"
    />
  </svg>
);
